import { Cookies } from "react-cookie";
import uuid from "uuid/v4";
import {
  COMPARA_COOKIES_SESSION_ID,
  COMPARA_COOKIES_USER_ID,
  IN_ONE_YEAR,
  IN_THIRTY_MINUTES
} from "./constants";

const setCookie = (name: string, value: string, expires: Date) => {
  const cookies = new Cookies(document.cookie);

  if (!cookies.get(name)) {
    cookies.set(name, value, { expires });
  }
};

const setUserId = () => setCookie(COMPARA_COOKIES_USER_ID, uuid(), IN_ONE_YEAR);
const setSessionId = () => setCookie(COMPARA_COOKIES_SESSION_ID, uuid(), IN_THIRTY_MINUTES);

export const getComparaCookies = () => {
  const cookies = new Cookies(document.cookie);
  return {
    sessionId: cookies.get(COMPARA_COOKIES_SESSION_ID),
    userId: cookies.get(COMPARA_COOKIES_USER_ID)
  };
};

export const setCookies = () => {
  setUserId();
  setSessionId();
};
